export default __webpack_public_path__ + "static/media/asus.0d9f5fe3.jpg";